<template>
  <div id="vproduct_app">
    <router-view v-if="isReloadAlive"></router-view>
  </div>
</template>

<script>
/**
 * @author 19185247 刘云飞
 * @description 使用vue-router重新路由到当前页面，页面是不会刷新的，旧有的方案是watch：$router,再去初始化相关变量，然后调用接口等步骤，逻辑较复杂，容易出错。故采用如下方案：
 * 参考 https://www.cnblogs.com/yinn/p/9056731.html
 * @date 2020-10-10
 */
import { mapMutations } from 'vuex'

export default {
  name: 'app',
  async mounted() {
    const flag = await this.$$isMiniProgramAsync()
    this.setMinprogram(flag)
  },
  methods: {
    ...mapMutations(['setMinprogram']),
    /**
     * default show loading before reload
     */
    reload(showLoading = true) {
      this.$$loading(showLoading)
      this.isReloadAlive = false
      this.$nextTick(() => {
        this.isReloadAlive = true
      })
    }
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isReloadAlive: true
    }
  }
}
</script>

<style></style>
